<template>
    <div class="response-inspector">
        <div class="response-inspector--body">
            <or-collapsible
                :title="$t('model.nlu-model.sidebar.responseinspector.responseinspector.testPhrase')"
                :open="isTestPhraseOpened"
            >
                <div class="text">
                    {{phrase}}
                </div>
                <div v-if="!isPhraseAnUtterance">
                    <or-button
                        class="add-to-response-button"
                        size="small"
                        type="secondary"
                        icon="add"
                        color="primary"
                        @click="addToResponse"
                        :loading="isPairUpdating"
                    >
                      {{ $t('model.nlu-model.sidebar.responseinspector.responseinspector.addTestPhrase') }}
                    </or-button>
                </div>
            </or-collapsible>
            <or-collapsible
                :title="$t('model.nlu-model.sidebar.responseinspector.responseinspector.response')"
                :open="isResponseOpened"
            >
                <div class="response-confidence">
                    <div class="text">
                      {{ $t('model.nlu-model.sidebar.responseinspector.responseinspector.confidence') }}
                    </div>
                    <div class="text">
                        {{response.score || 0}}%
                    </div>
                </div>
                <response-preview
                    :response="response"
                />
            </or-collapsible>
            <or-collapsible
                v-if="response.confirmationPhrase"
                :title="$t('model.nlu-model.sidebar.responseinspector.responseinspector.confirmationPhrase')"
                :open="isConfirmationPhraseOpened"
            >
                <div class="text">
                    {{response.confirmationPhrase}}
                </div>
            </or-collapsible>
            <or-collapsible
                v-if="predictedEntities.length !== 0"
                :title="$t('model.nlu-model.sidebar.responseinspector.responseinspector.entities')"
                :open="areEntitiesOpened"
            >
                <entity-item
                    v-for="(entity,index) in predictedEntities"
                    :key="index"
                    :entity="entity"
                    :headNode="true"
                />
            </or-collapsible>
        </div>
        <div class="response-inspector--actions">
            <or-button
                type="secondary"
                color="primary"
                @click="$emit('close')"
            >
              {{ $t('generic.back') }}
            </or-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ResponsePreview from './ResponsePreview'
import EntityItem from './EntityItem'
import { MachineLearningTestPreviewService } from '@/services/utterance/machine-learning-test-preview.service'

export default {
  components: {
    ResponsePreview,
    EntityItem
  },

  props: {
    phrase: String,
    /* {
            answer      : String,
            answerId    : String,
            context     : String,
            contextId   : String,
            score       : Number,
            type        : String, // TEXT | FLOW | JSON

            confirmationPhrase: {
                type    : String,
                required: false,
            },
        }, */
    response: Object,
    entities: Array,
    utterances: Array
  },

  data () {
    return {
      wasPhraseAdded: false,
      isPairUpdating: false,
      isTestPhraseOpened: true,
      isResponseOpened: true,
      isConfirmationPhraseOpened: false,
      areEntitiesOpened: false

    }
  },

  computed: {
    ...mapState('knowledgebase/entities', ['allEntities']),

    // Adding type & Getting correct entity for ML entity
    predictedEntities () {
      const {
        predictedMlEntities,
        predictedNotMlEntities
      } = MachineLearningTestPreviewService.cleanUpTestResponseEntities(
        this.allEntities.value,
        this.$props.entities
      )
      this.mlLabelingService.updatePossibleMlEntities(this.allEntities.value)
      const mlEntities = this.mlLabelingService.generatePreviewTree(predictedMlEntities)
      return [...predictedNotMlEntities, ...mlEntities]
    },

    isPhraseAnUtterance () {
      return this.wasPhraseAdded || this.utterances.includes(this.phrase)
    },

    mlLabelingService () {
      return new MachineLearningTestPreviewService()
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['createPair']),

    async addToResponse () {
      this.isPairUpdating = true
      const newUtterance = {
        target: 'utterance',
        applicationName: this.$props.response.context,
        intentName: this.$props.response.answer,
        intentType: this.$props.response.type,
        utteranceText: this.$props.phrase
      }
      try {
        await this.createPair(newUtterance)
        this.wasPhraseAdded = true
      } catch (err) {
        console.error('Could not update utterance:', err.toString())
      }
      this.isPairUpdating = false
    }
  }
}
</script>

<style scoped lang="scss">
    .response-inspector {
        display: flex;
        flex-direction: column;
        width: 100%;

        .add-to-response-button {
            margin-top: 8px;
            border: 0;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: -0.15px;
            line-height: 21px;
        }

        .response-inspector--body, .response-inspector--actions {
            padding: 16px;
        }

        .response-inspector--body {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            overflow-x: scroll;
        }

        .response-inspector--actions {
            display: flex;
            justify-content: flex-end;
            border-top: 1px solid $or-grey-medium;
        }

        ::v-deep .header-content {
            font-size: 14px;
            font-weight: bold;
        }

        ::v-deep .or-collapsible {
            border-bottom: 0;
        }

        .response-confidence {
            display: flex;
            justify-content: space-between;
            margin-bottom: 8px;
            .text {
                color: rgb(145, 150, 157);
            }
        }

        .text {
            font-size: 14px;
            letter-spacing: -0.15px;
            line-height: 21px;
        }

    }
</style>
